<template>
	<div>
		<sky-charts :colors="config.color" :extend="extend" :config="config" :chart-data="chartData" :showTitle="false"
			:showShadow="false"></sky-charts>
	</div>
</template>
<script>
export default {
	props: {
		data: {
			type: Object,
		},
	},
	computed: {
		config() {
			return {
				type: 'veLine',
				height: this.data.height,
				// width: '700px',
				columns: this.data && this.data.columns ? this.data.columns : [],
				color: this.data && this.data.color ? this.data.color : ['#3DA1FF'],
				chartSettings: this.data.chartSettings,
				legend: this.data.legend
			};
		},
		extend() {
			return {
				series: {
					type: 'line',
					smooth: true
				},
				
				xAxis: {
					axisLabel: {
						show: true,
						color: '#6f6f6f',
						fontSize: 12
					},
					axisLine: {
						show: true,
						lineStyle: {
							type: "solid",
							color: '#bfbfbf'
						},
					},
				},
				yAxis: {
					axisLabel: {
						show: true,
						color: '#6f6f6f',
						fontSize: 12
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: 'dashed',
							color: '#e6e6e6'
						}
					},
          ...this.data?.yAxis,
				},
				tooltip: this.data && this.data.toolTip ? this.data.toolTip : undefined,

			};
		},
		chartData() {
			return this.data && this.data.rows ? this.data.rows : [];
		},
	},
	data() {
		return {};
	},
	methods: {},
	components: {},
};
</script>
<style lang="scss" scoped>
::v-deep  .data-empty {
	height: 160px;
}
</style>
